/**
 * @param {import('.').GtagWrapper} gtag
 */
export default function runBlock(gtag) {
  'ngInject'
  gtag.init()
}
